/** @jsx jsx */
import { jsx } from '@emotion/react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

type Props = {
  count?: number | null;
};

export const ENROLLMENT_COUNT_THRESHOLD = 1500;

const HeroTotalEnrollmentCount = ({ count }: Props) => {
  if (!count || count < ENROLLMENT_COUNT_THRESHOLD) {
    return null;
  }

  return (
    <Typography2 component="p" variant="bodyPrimary">
      <FormattedMessage
        message={_t('{enrollmentCount} already enrolled')}
        enrollmentCount={
          <strong>
            <FormattedNumber value={count} />
          </strong>
        }
      />
    </Typography2>
  );
};

export default HeroTotalEnrollmentCount;
